import { observer } from 'mobx-react';
import * as React from 'react';
import LoadingIndicator from '../components/LoadingIndicator';
import { Anonymous, Unauthorized, type Errored } from '../CurrentUserStore/Types';
import LoginButton from './LoginButton';

interface Props {
  currentUserState: Anonymous | Unauthorized | Errored;
}

const Action: React.FC<Props> = ({ currentUserState }) => {
  switch (currentUserState.kind) {
    case 'anonymous':
      return (
        <LoadingIndicator
          className="mx-auto"
          type="bubbles"
          color="black"
          height={100}
          width={100}
          delay={0}
        />
      );
    case 'unauthorized':
    case 'errored':
      return <LoginButton />;
  }
};

export default observer(Action);
